import axios from 'axios';
import Setting from '../../../../setting';

const copyTo = (source, target) => {
  for (let key in source) {
    if (typeof source[key] === 'object') {
      if (target[key] == null) {
        target[key] = {};
      }
      copyTo(source[key], target[key]);
    } else {
      target[key] = source[key];
    }
  }
};

const basePath = process.env.VUE_APP_BASE_PATH;
const rootPath = basePath == '' || basePath == null ? '/static/' : '/' + basePath + '/static/';

/**
 * 系统信息
 * */
export default {
  namespaced: true,
  state: {
    // 根目录
    rootPath,
    // 配置信息
    ...Setting
  },
  getters: {
    get: state => {
      return state;
    },
    getApiBaseURL: state => {
      return process.env.NODE_ENV === 'development' ? state.apiBaseURL.dev : state.apiBaseURL.prd;
    }
  },
  actions: {
    /**
     * @description 加载配置
     * @param {Object} state vuex state
     */
    async init({ state, rootState }) {
      let setting = window.setting;

      if (setting) {
        copyTo(setting, state);
      }

      // 更新API地址
      axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? state.apiBaseURL.dev : state.apiBaseURL.prd;

      // 更新自定义样式
      if (state.layout) {
        for (let key in state.layout) {
          rootState.admin.layout[key] = state.layout[key];
        }
      }
    }
  }
};
